import React from 'react';

export const WarningIcon = ({ size = 24, color = '#BA1A1A' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
    <path d="M0 21L12 0L24 21H0ZM3.775 18.75H20.225L12 4.375L3.775 18.75ZM12 17.5C12.3167 17.5 12.5833 17.3917 12.8 17.175C13.0167 16.9583 13.125 16.6917 13.125 16.375C13.125 16.0583 13.0167 15.7917 12.8 15.575C12.5833 15.3583 12.3167 15.25 12 15.25C11.6833 15.25 11.4167 15.3583 11.2 15.575C10.9833 15.7917 10.875 16.0583 10.875 16.375C10.875 16.6917 10.9833 16.9583 11.2 17.175C11.4167 17.3917 11.6833 17.5 12 17.5ZM10.875 14H13.125V8.75H10.875V14Z" fill={color} />
  </svg>
);



// WEBPACK FOOTER //
// ./src/assets/icons/Warning.icon.jsx